import { Component } from '@angular/core';
import { LandingHeaderComponent } from './header/header.component';
import { LandingFooterComponent } from './footer/footer.component';

import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'landing',
    imports: [
        LandingHeaderComponent,
        LandingFooterComponent,
        RouterOutlet
    ],
    templateUrl: './landing.component.html',
    styleUrl: './landing.component.scss'
})
export class LandingComponent {

}
